module.exports = __webpack_public_path__ + "static/main-86fc83b8456e34e734a64c0cc24e19ea.png";